<script setup lang="ts">
interface FairDialogContentProps {
  text?: string
}

withDefaults(defineProps<FairDialogContentProps>(), {
  text: undefined,
})
</script>

<template>
  <div class="fair-dialog-content">
    <slot>
      <p
        v-if="text"
        class="fair-dialog-content__text"
      >
        {{ text }}
      </p>
    </slot>
  </div>
</template>
